
<template v-slot:activator="{ on }">
  <v-layout row justify-center>
    <v-dialog v-model="activeNew" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <div class="container pb-0 pt-3 ml-3">
            <span class="headline">Novo Parceiro</span>
          </div>
        </v-card-title>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container grid-list-md>
            <template>
              <div class="container margin-zero">
                <v-dialog v-model="dialog" width="500">
                <v-card>
                  <!-- Loading -->
                  <div v-if="isLoad" class="text-xs-center">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                    <div>
                      <b>Por favor aguarde, enviando dados...</b>
                    </div>
                  </div>

                  <!-- IF ERROR -->
                  <v-flex v-show="showError">
                    <div class="red text-center">
                      <v-icon color="white">error</v-icon>
                      <span class="white--text"
                        ><p>
                          <strong>Erro ao Cadastrar Estabelecimento:</strong>
                        </p></span
                      >
                      <span class="white--text"
                        ><strong>
                          {{ errors["error"] }}
                        </strong></span
                      >
                    </div>
                    <v-btn
                      color="blue darken-1"
                      flat="flat"
                      @click.stop="dialog = false"
                      @click="disableError"
                    >
                      Fechar
                    </v-btn>
                  </v-flex>

                  <!-- IF SUCCESS -->
                  <v-flex v-show="showSuccess">
                    <div class="green text-center">
                      <v-icon color="white">done</v-icon>
                      <span class="white--text">
                        <p>
                          <strong>
                            Estabelecimento cadastrado com sucesso.
                          </strong>
                        </p>
                      </span>
                    </div>
                    <v-btn
                      color="blue darken-1"
                      flat="flat"
                      @click.stop="dialog = false"
                      @click="disableNew"
                    >
                      Fechar
                    </v-btn>
                  </v-flex>
                </v-card>
              </v-dialog>
              </div>
            </template>

            <!-- FORM STARTS HERE -->
            <div class="container pr-5 pl-5 margin-zero">
              <div class="blue">
                <v-subheader class="white--text"
                  >Dados do Estabelecimento</v-subheader
                >
              </div>
              <v-flex>
                <v-text-field
                  v-model="account.name"
                  :rules="presenceRules"
                  label="Nome do Estabelecimento"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  v-model="account.email"
                  :rules="presenceRules"
                  label="E-mail"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  v-model="account.rg"
                  :rules="presenceRules"
                  label="RG"
                ></v-text-field>
              </v-flex>

              <v-flex>
                <div class="document-type">
                  <input
                    v-on:change="setAccountType"
                    type="radio"
                    class="document-type-radio"
                    name="document-type"
                    value="personal" />
                  <span>Pessoal</span>
                  <input
                    v-on:change="setAccountType"
                    type="radio"
                    class="document-type-radio"
                    name="document-type"
                    value="business" />
                  <span>Comercial</span>
                </div>
              </v-flex>
              <v-flex>
                <v-select
                  v-model="account.category_id"
                  :items="categories"
                  item-text="name"
                  item-value="id"
                  label="Ramo de Atividade"
                  data-vv-name="Selecione"
                  :rules="presenceRules"
                  required
                ></v-select>
              </v-flex>
              <v-flex v-if="formSelectedAccountType === 'personal'">
                <v-text-field
                  return-masked-value
                  mask="###.###.###-##"
                  v-model="account.cpf"
                  :required="formDocumentType === 'cpf' ? true : false"
                  hint="14"
                  minLength="14"
                  maxLength="44"
                  :counter="14"
                  :rules="presenceRules"
                  label="CPF"
                ></v-text-field>
              </v-flex>
              <v-flex v-if="formSelectedAccountType === 'business'">
                <v-text-field
                  return-masked-value
                  mask="##.###.###/####-##"
                  v-model="account.cnpj"
                  :required="formSelectedAccountType === 'business' ? true : false"
                  label="CNPJ"
                  hint="18"
                  minLength="18"
                  maxLength="18"
                  :counter="18"
                ></v-text-field>
                <v-text-field
                  v-model="account.cpf"
                  v-on:change="setSameCPFBothData"
                  mask="###.###.###-##"
                  :required="formSelectedAccountType === 'business' ? true : false"
                  hint="14"
                  minLength="14"
                  maxLength="44"
                  :counter="14"
                  :rules="presenceRules"
                  label="CPF do Representante"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  v-model="account.ownerName"
                  :rules="presenceRules"
                  label="Nome do Representante"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <!-- change to date format -->
                <v-text-field
                  return-masked-value
                  mask="##/##/####"
                  v-model="account.birthday"
                  :rules="presenceRules"
                  label="Data de nascimento do Sócio"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  return-masked-value
                  mask="##/##/####"
                  v-model="account.partnerBirthday"
                  :rules="presenceRules"
                  label="Data de Constituição"
                ></v-text-field>
              </v-flex>
              <v-flex v-if="formSelectedAccountType === 'business'">
                <v-text-field
                  return-masked-value
                  mask="##/##/####"
                  v-model="account.constitutionDate"
                  :rules="presenceRules"
                  label="Data de Constituição da Empresa"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  v-model="account.razaoSocial"
                  :rules="presenceRules"
                  label="Razão Social"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  v-model="account.inscricaoEstadual"
                  label="Inscrição Estadual"
                  hint="9"
                  minLength="9"
                  maxLength="9"
                  :counter="9"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  v-model="account.fantasyName"
                  label="Nome Fantasia"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-checkbox
                  v-model="account.master"
                  label="Parceiro Master?"
                  required
                ></v-checkbox>
              </v-flex>
              <v-flex>
                <v-checkbox
                  v-model="account.executive"
                  label="Parceiro Executivo?"
                  required
                ></v-checkbox>
              </v-flex>
              <div class="blue">
                <v-subheader class="white--text">Dados Bancários</v-subheader>
              </div>
              <v-flex>
                <v-text-field
                  v-model="bankAccountAttributes.code"
                  :rules="presenceRules"
                  label="Código do Banco"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  v-model="bankAccountAttributes.agency"
                  :rules="presenceRules"
                  label="Agência"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  v-model="bankAccountAttributes.number"
                  :rules="presenceRules"
                  label="Número da Conta"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <!-- :rules="presenceRules" -->
                <v-text-field
                  v-model="bankAccountAttributes.number_digit"
                  label="Dígito da Conta"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-select
                  v-model="bankAccountAttributes.kind"
                  :items="accountKind"
                  :rules="presenceRules"
                  item-text="name"
                  item-value="value"
                  data-vv-name="Selecione"
                  label="Tipo de Conta da Bancária"
                  required
                ></v-select>
              </v-flex>
              <v-flex>
                <!-- :rules="presenceRules" -->
                <v-text-field
                  v-model="bankAccountAttributes.operation"
                  label="Operação"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  v-model="bankAccountAttributes.holder_name"
                  :rules="presenceRules"
                  label="Titular"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <div class="document-type">
                  <input
                    v-on:change="checkDocumentType"
                    type="radio"
                    class="document-type-radio"
                    name="account-type"
                    value="cpf" />
                  <span>CPF da conta</span>
                  <input
                    v-on:change="checkDocumentType"
                    type="radio"
                    class="document-type-radio"
                    name="account-type"
                    value="cnpj" />
                  <span>CNPJ da conta</span>
                </div>
              </v-flex>
              <v-flex v-if="formDocumentType === 'cpf'">
                <v-text-field
                  return-masked-value
                  mask="###.###.###-##"
                  v-model="bankAccountAttributes.document_number"
                  :rules="cpfRules"
                  label="Usar CPF na conta"
                ></v-text-field>
              </v-flex>
              <v-flex v-else>
                <v-text-field
                  return-masked-value
                  mask="##.###.###/####-##"
                  v-model="bankAccountAttributes.document_number"
                  :rules="cnpjRules"
                  label="Usar CNPJ na conta"
                ></v-text-field>
              </v-flex>
              <div class="blue">
                <v-subheader class="white--text">Endereço</v-subheader>
              </div>
               <v-flex>
                <v-text-field
                  return-masked-value
                  mask="#####-###"
                  v-model="addressAttributes.zip_code"
                  :rules="presenceRules"
                  label="CEP"
                  hint="9"
                  minLength="9"
                  maxLength="9"
                  :counter="9"
                  @keyup="getCepData()"
                ></v-text-field>
                <p
                  class="message_cep"
                  v-if="showError && (!addressAttributes.street || !addressAttributes.number)"
                >
                  Não foi possível carregar as informações do seu endereço.
                  Por favor, preencha manualmente.
                </p>
              </v-flex>
              <v-flex>
                <v-text-field
                  v-model="addressAttributes.street"
                  :rules="presenceRules"
                  label="Lougradouro/Rua"
                  :disabled="disableFieldsAddress"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="addressAttributes.number"
                  :rules="presenceRules"
                  label="Nº"
                  ref="address_number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="addressAttributes.complement"
                  label="Complemento"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  v-model="addressAttributes.district"
                  :rules="presenceRules"
                  label="Bairro"
                  :disabled="disableFieldsAddress"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  v-model="addressAttributes.city"
                  :rules="presenceRules"
                  label="Cidade"
                  :disabled="disableFieldsAddress"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-select
                  v-model="addressAttributes.state"
                  :items="states"
                  label="Estado"
                  data-vv-name="Selecione"
                  :disabled="disableFieldsAddress"
                  required
                ></v-select>
              </v-flex>

              <v-flex>
                <v-text-field
                  return-masked-value
                  mask="(##) #####-####"
                  v-model="phoneAttributes.number"
                  :rules="presenceRules"
                  label="Celular"
                  hint="15"
                  minLength="15"
                  maxLength="15"
                  :counter="15"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-select
                  v-model="account.chip"
                  :items="sim_card_kids"
                  label="Operadora"
                  data-vv-name="Selecione"
                  :rules="presenceRules"
                  required
                ></v-select>
              </v-flex>
              <v-flex>
                <v-text-field
                  return-masked-value
                  mask="(##) ####-####"
                  v-model="phoneAttributes.number_fixed"
                  label="Telefone fixo"
                  hint="14"
                  minLength="14"
                  maxLength="14"
                  :counter="14"
                ></v-text-field>
              </v-flex>

              <div class="blue">
                <v-subheader class="white--text">Plano de Taxas</v-subheader>
              </div>
              <v-flex>
                <v-select
                  :items="ratePlans"
                  v-model="selectedRateProfileId"
                  item-text="name"
                  item-value="id"
                  label="Plano de taxas do estabelecimento"
                  no-data-text="Nenhum plano criado ainda"
                ></v-select>
              </v-flex>
              <v-flex>
                <v-btn flat color="blue darken-1" @click="openPlanDialog">
                  + Criar novo plano
                </v-btn>
              </v-flex>
            </div>
          </v-container>
        </v-form>

        <v-dialog v-model="planDialog" max-width="960" scrollable>
          <rate-profile
            embedded
            @saved="onPlanSaved"
            @close="planDialog = false"
          />
        </v-dialog>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            color="blue darken-1"
            text
            @click="disableNew"
            >Fechar</v-btn
          >
          <v-btn
            class="white--text"
            color="blue darken-1"
            text
            @click="sendAccount"
            >Enviar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<!--eslint-disable-->
<script>
import { mapGetters, mapActions } from "vuex";
import Flowit from "@/services/flowit";
const axios = require("axios");

export default {
  components: {
    RateProfile: () => import("@/components/desktop/partners/RateProfile.vue"),
  },
  created() {
    this.$store.dispatch("account/getAccount");
    this.loadRatePlans();
  },
  data() {
    return {
      dialog: false,
      ratePlans: [],
      selectedRateProfileId: null,
      planDialog: false,
      valid: true,
      load: false,
      formDocumentType: "cpf",
      formSelectedAccountType: "personal",
      disableFieldsAddress: false,
      accountTypes: [
        { name: "Pessoal", value: "personal" },
        { name: "Comercial", value: "business" },
      ],
      sim_card_kids: [
        "vivo", "oi", "tim", "claro"
      ],
      states: [
        "AC",
        "AL",
        "AM",
        "AP",
        "BA",
        "CE",
        "DF",
        "ES",
        "GO",
        "MA",
        "MT",
        "MS",
        "MG",
        "PA",
        "PB",
        "PR",
        "PE",
        "PI",
        "RJ",
        "RN",
        "RO",
        "RS",
        "RR",
        "SC",
        "SE",
        "SP",
        "TO",
      ],
      accountKind: [
        { name: "Conta Corrente", value: "CC" },
        { name: "Conta Poupança", value: "CP" },
      ],
      account: {
        origin: "Painel",
        name: "",
        email: "",
        cpf: "",
        rg: "",
        chip: "",
        category_id: "",
        birthday: "",
        partnerBirthday: "",
        constitutionDate: "",
        accountType: "",
        cnpj: "",
        razaoSocial: "",
        inscricaoEstadual: "",
        ownerName: "",
        fantasyName: "",
        installmentLimit: 12,
        master: true,
        executive: false,
        panelUrl: "",
        webhook: "",
        panelColor: "",
      },
      addressAttributes: {
        street: "",
        number: "",
        complement: "",
        district: "",
        city: "",
        state: "",
        zip_code: "",
      },
      phoneAttributes: {
        area: "",
        number: "",
        kind: "",
      },
      bankAccountAttributes: {
        code: "",
        agency: "",
        number: "",
        number_digit: "",
        kind: "",
        operation: "",
        holder_name: "",
        document_number: "",
      },
      presenceRules: [(v) => !!v || "Campo é requirido"],
      cpfRules: [
        (v) => (!!v || v.length !== 14) || "CPF inválido",
      ],
      cnpjRules: [
        (v) => (!!v || v.length !== 18) || "CNPJ inválido",
      ],
      checkDocumentType: [(v) => this.formDocumentType = v.target.value],
    };
  },
  computed: {
    ...mapGetters({
      activeNew: "partners/activeNew",
      color: "account/color",
      isLoad: "partners/isLoad",
      partner: "partners/account",
      errors: "partners/errors",
      showError: "partners/showError",
      showSuccess: "partners/showSuccess",
      categories: "partners/categoriesList",
      viaCep: "partners/getCep"
    }),
    pages() {
      return 0;
    },
  },
  methods: {
    loadRatePlans() {
      Flowit.partners
        .rateProfiles()
        .then((response) => {
          this.ratePlans = response.data.rate_profiles || [];
        })
        .catch(() => {});
    },
    openPlanDialog() {
      this.planDialog = true;
    },
    onPlanSaved(plan) {
      this.planDialog = false;
      this.loadRatePlans();
      if (plan && plan.id) this.selectedRateProfileId = plan.id;
    },
    checkAccountType(v){
      this.formSelectedAccountType = v.target.value;
    },
    getCepData() {
      var zipcode = this.addressAttributes.zip_code;      
      if (zipcode.length <= 8) return false;
      
      this.$store.dispatch("partners/getCep", zipcode)
    },
    setAccountType(v) {
      this.account.accountType = v.target.value;
      this.checkAccountType(v)
    },
    disableError() {
      this.$store.dispatch("partners/showError", false);
    },
    disableNew() {
      this.$store.dispatch("partners/activeNew", false);
      this.$store.dispatch("partners/showError", false);
      this.$store.dispatch("partners/showSuccess", false);
      this.$store.dispatch("partners/isLoad", false);
    },
    sendAccount() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("partners/isLoad", true);
        this.dialog = true;
        this.accountParams = {
          partner: {
            origin: this.account.origin,
            name: this.account.name,
            email: this.account.email,
            cpf: this.account.cpf,
            chip: this.account.chip,
            category_id: this.account.category_id,
            birthday: this.account.birthday,
            partner_birthday: this.account.partnerBirthday,
            constitution_date: this.account.constitutionDate,
            account_type: this.account.accountType,
            cnpj: this.account.cnpj,
            razao_social: this.account.razaoSocial,
            inscricao_estadual: this.account.inscricaoEstadual,
            owner_name: this.account.ownerName,
            fantasy_name: this.account.fantasyName,
            installment_limit: this.account.installmentLimit,
            master: this.account.master,
            executive: this.account.executive,
            address_attributes: {
              street: this.addressAttributes.street,
              number: this.addressAttributes.number,
              complement: this.addressAttributes.complement,
              district: this.addressAttributes.district,
              city: this.addressAttributes.city,
              state: this.addressAttributes.state,
              zip_code: this.addressAttributes.zip_code,
            },
            phones_attributes: {
              area: this.phoneAttributes.number.toString().slice(1, 3),
              number: this.phoneAttributes.number.toString().slice(5),
            },
            bank_account_attributes: {
              code: this.bankAccountAttributes.code,
              agency: this.bankAccountAttributes.agency,
              number: this.bankAccountAttributes.number,
              number_digit: this.bankAccountAttributes.number_digit,
              kind: this.bankAccountAttributes.kind,
              operation: this.bankAccountAttributes.operation,
              holder_name: this.bankAccountAttributes.holder_name,
              document_number: this.bankAccountAttributes.document_number,
            },
          },
          rate_profile_id: this.selectedRateProfileId,
        };
        this.$store.dispatch("partners/createAccount", this.accountParams);
      }
    },
  },
  watch: {
    activeNew(opened) {
      if (opened) this.loadRatePlans();
    },
    isLoad(newValue) {
      this.load = newValue;
    },
    viaCep(value){
      this.addressAttributes.street = value.logradouro;
      this.addressAttributes.district = this.viaCep.bairro;
      this.addressAttributes.city = this.viaCep.localidade;
      this.addressAttributes.state = this.viaCep.uf;
      this.disableFieldsAddress = true;
    },
    account(value) {
      this.disableNew();
      this.$router.push({ name: "partner-show", params: { id: value.id } });
    },
  },
};
</script>
<style>
  .margin-zero {
    margin: 0px ;
    padding: 0px ;
  }
  .document-type {
    text-align: center;
  }
  .document-type-radio {
    margin-left: 20px;
  }
  span {
    margin-left: 5px;
    font-size: large;
    color: rgba(70, 70, 70, 0.8);
  }
  .v-card__title{
    padding: 0;
  }
  .v-form > .container{
    padding: 0;
  }
  .blue{
    margin-top: 2em;
  }
  .v-card__actions{
    margin-top: 2.2em;
  }
  .message_cep {
    font-size: 0.9em;
    color: red;
  }
</style>